import type { IDateRangeState } from '../hooks';
import type { DateTimeFilter } from '../types';

import { BlockStack, Box, OptionList, Scrollable, Select, useBreakpoints } from '@shopify/polaris';

import { DateTimeFilterAddition } from './DateTimeFilterAddition';
import { DATE_TIME_COMPARISON_FILTERS } from '~/presentation/ui';
import { useDateTimeFilter } from '../hooks';
import { dayjsTz } from '~/utils/dayjs';

export interface IDateTimeFilterAddition {
  title: string;
  initialPicked?: DateTimeFilter;
  rangers: DateTimeFilter[];
}

export interface DateTimeFiltersProps {
  setDateTimePicked: (value: IDateRangeState) => void;
  dateTimePicked: DateTimeFilter;
  allRanges: DateTimeFilter[];
  rangeAddition?: IDateTimeFilterAddition;
  isCompare?: boolean;
}

export function DateTimeFilters(props: DateTimeFiltersProps) {
  const { setDateTimePicked, dateTimePicked, allRanges, isCompare } = props;

  const { DATE_TIME_FILTERS } = useDateTimeFilter();
  const { mdDown } = useBreakpoints();

  const rangesDefault = isCompare ? [...DATE_TIME_COMPARISON_FILTERS] : [...DATE_TIME_FILTERS];

  const handleChangeFilterBySelect = (value: string) => {
    const result =
      allRanges.find(({ title, alias }) => title === value || alias === value) || allRanges[0];

    setDateTimePicked({
      start: dayjsTz(result.since).toDate(),
      end: dayjsTz(result.until).toDate(),
      alias: result.alias,
    });
  };

  const handleChangeFilterByOption = (value: string[]) => {
    const result = allRanges.find((range) => range.alias === value[0]) || allRanges[0];
    setDateTimePicked({
      start: dayjsTz(result.since).toDate(),
      end: dayjsTz(result.until).toDate(),
      alias: result.alias,
    });
  };

  return (
    <Box
      maxWidth={mdDown ? '516px' : '250px'}
      width={mdDown ? '100%' : '250px'}
      padding={{ xs: '500', md: '0' }}
      paddingBlockEnd={{ xs: '100', md: '0' }}
    >
      {mdDown ? (
        <Select
          label="dateRangeLabel"
          labelHidden
          onChange={(value) => handleChangeFilterBySelect(value)}
          value={dateTimePicked?.title || dateTimePicked?.alias || ''}
          options={allRanges.map(({ alias, title }) => title || alias)}
        />
      ) : (
        <Scrollable style={{ maxHeight: '356px' }}>
          <Box>
            <BlockStack>
              <DateTimeFilterAddition {...props} />
              <OptionList
                options={rangesDefault.map((range) => ({
                  value: range.alias,
                  label: range.title,
                }))}
                selected={dateTimePicked ? [dateTimePicked.alias] : []}
                onChange={(value) => handleChangeFilterByOption(value)}
              />
            </BlockStack>
          </Box>
        </Scrollable>
      )}
    </Box>
  );
}
